export const localesEn = {
  "lnb.sideBar.body.main.link": "Dashaboard",
  "lnb.sideBar.body.smartthings.link": "SmartThings Pro",
  "lnb.sideBar.body.facilities.link": "Facilities",
  "lnb.sideBar.body.plans.link": "Plans",
  "lnb.sideBar.body.contracts.link": "Contracts & Billing",
  "lnb.sideBar.body.people.link": "People",
  "lnb.sideBar.body.operations.link": "Operations",
  "lnb.sideBar.body.info.link": "Info & Settings",
  "lnb.sideBar.body.accessBooking.link": "Access & Bookings",
  "lnb.sideBar.body.accessRecord.link": "Access Records",
  "lnb.sideBar.body.monitoring.link": "Space Monitoring",
  "lnb.sideBar.body.building.link": "Buildings",
  "lnb.sideBar.body.product.link": "Products",
  "lnb.sideBar.body.workorder.link": "Work Orders",
  "lnb.sideBar.body.cs.link": "VoC",
  "lnb.sideBar.body.contract.link": "Contracts",
  "lnb.sideBar.body.contractGroup.link": "Contract Groups",
  "lnb.sideBar.body.contract-s2.link": "Reservation Contracts",
  "lnb.sideBar.body.provider.link": "Billing Entities",
  "lnb.sideBar.body.reservation.link": "Bookings",
  "lnb.sideBar.body.commonSpaceSettlement.link": "Common Space Settlement",
  "lnb.sideBar.body.user.link": "Users",
  "lnb.sideBar.body.visitor.link": "Visitors",
  "lnb.sideBar.body.notice.link": "Notices",
  "lnb.sideBar.body.org.link": "Tenants",
  "lnb.sideBar.body.billing.link": "Billing Schedule",
  "lnb.sideBar.body.billing-s2.link": "Reservation Billing",
  "lnb.sideBar.body.option.link": "Settings",
  "lnb.sideBar.body.guide.link": "User Guide",
  "lnb.sideBar.body.voc.link": "VoC Settings",
  "lnb.sideBar.body.customLink.link": "External Link",
  "lnb.sideBar.body.userAdditionalInfo.link": "User Additional Info",
  "lnb.sideBar.body.price.link": "Pricing",
  "lnb.sideBar.body.cctv.link": "CCTV",
  "lnb.sideBar.body.login": "Last login",
  "lnb.sideBar.body.accessDevice.link": "Access Devices",
  "lnb.sideBar.body.accessControl.link": "Access Control",
  "lnb.sideBar.body.reservationConfig.link": "Booking Info.",
  "lnb.sideBar.body.setting.link": "STPM Settings",
  "lnb.sideBar.body.help.link": "Guidelines",

  // 공용공간 예약현황
  "reservation.list.body.button.text": "View daily reservations",
  "reservation.display.body.title": "Space reservation Schedule",
  "reservation.display.toast.title": "The space reservation policies vary by company. Please check the Taap app for the exact availability.",
  "reservation.display.body.private": "Private",
  "reservation.display.body.attendeeInfo.private": "Private",
  "reservation.display.detail.private": "Private",
  "reservation.display.setting.building": "Building",
  "reservation.display.setting.floor": "Floor",
  "reservation.display.setting.type": "Space type",
  "reservation.display.setting.room": "Meeting Room",
  "reservation.display.setting.desk": "Desk",
  "reservation.display.setting.amenity": "Amenity",
  "reservation.display.setting.all": "ALL",
  "reservation.display.setting.title": "Please select the search conditions",

  // 웹 버전 업데이트 안내
  "update.available": "A new version is available. Refresh to get the latest.",
  "update.reload": "Refresh",
  "update.collapse": "Collapse",
  "update.expand": "Expand update notice",
  "update.badge": "New version available.",
};
